var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIconFooterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.3333C10.1667 11.2222 12 8.25926 12 5.44444C12 4.2657 11.4205 3.13524 10.3891 2.30175C9.35764 1.46825 7.95869 1 6.5 1C5.04131 1 3.64236 1.46825 2.61091 2.30175C1.57946 3.13524 1 4.2657 1 5.44444C1 8.25926 2.83333 11.2222 6.5 14.3333Z",
    stroke: "white",
    strokeMiterlimit: 8,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.66667C7.25939 7.66667 7.875 7.06971 7.875 6.33333C7.875 5.59695 7.25939 5 6.5 5C5.74061 5 5.125 5.59695 5.125 6.33333C5.125 7.06971 5.74061 7.66667 6.5 7.66667Z",
    stroke: "white",
    strokeMiterlimit: 8,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconFooterWhite);
export default __webpack_public_path__ + "static/media/location-icon-footer-white.7b4e93f0b9519f224724e5814153db91.svg";
export { ForwardRef as ReactComponent };